<template>
  <BaseModal v-if="!smAndDown" ref="modal" width="360" height="h-[408px]" title="لیست حساب های کاربری" icon="info" fill>
    <template #body>
      <div class="p-6">
        <div v-for="company in accounts" :key="company" class="mb-4" :class="company.status ? 'cursor-pointer' : 'cursor-not-allowed'" @click="company.status ? select = company.id : undefined">
          <div class="flex justify-between">
            <div class="flex">
              <div v-if="!company.avatar_url" class="flex items-center justify-center w-10 h-10 rounded bg-blue-dark-50 text-blue-dark-200">
                <BaseIcon
                  :icon="company.account_type === 'personal' ? 'account-circle' : 'domain'"
                />
              </div>
              <div
                v-else
                :style="{ 'background-image': 'url(' + company.avatar_url + ')', 'background-size': '100% 100%' }"
                class="border-[1.3px] border-primary-500 w-10 h-10 rounded-lg cursor-pointer"
              >
              </div>
              <div class="flex flex-col justify-between mr-3">
                <div class="text-sm font-bold text-blue-dark-500">
                  {{ company.title }}
                </div>
                <div class="text-xs text-blue-dark-200">
                  {{ company.account_type === 'personal' ? 'حقیقی' : 'حقوقی' }}
                </div>
              </div>
            </div>
            <div>
              <div v-if="!company.status" class="text-xs text-center text-red-600">
                <BaseIcon icon="error" fill />
                <div>مسدود</div>
              </div>
              <BaseIcon v-else-if="select === company.id" icon="radio-button-checked" class="text-blue-500" />
              <BaseIcon v-else icon="radio-button-unchecked" class="text-blue-dark-400" />
            </div>
          </div>
          <div class="border-b-[1px] w-full mt-3"></div>
        </div>
      </div>
      <div v-if="loading" class="flex flex-col gap-y-[22px] animate-pulse px-6">
        <div v-for="i in 3" :key="i" class="w-full h-[46px] bg-gray-300 rounded"></div>
      </div>
    </template>
    <template #footer="isActive">
      <div class="flex flex-row-reverse p-6">
        <v-btn class=" text-primary-500 hover:text-white hover:bg-blue-500 border-[1.3px] border-primary-500" @click="useAccount">
          <BaseIcon icon="check-circle" class="ml-2" />
          <span class="text-sm">
            ورود
          </span>
        </v-btn>
        <v-btn class=" text-primary-500 hover:text-white hover:bg-blue-500 ml-6 border-[1.3px] border-primary-500 " @click="closeDialog(isActive)">
          <BaseIcon icon="arrow-forward" class="ml-2" />
          <span class="text-sm">
            بازگشت
          </span>
        </v-btn>
      </div>
    </template>
  </BaseModal>
  <div v-else>
    <div @click="showAccounts = true">
      <BaseIcon icon="switch-account" class="text-primary-500" />
      <BaseIcon icon="arrow-down" class="text-primary-500" />
    </div>
    <BaseBottomSheet v-model="showAccounts" persistent>
      <div v-for="company in accounts" :key="company" class="mb-4" :class="company.status ? 'cursor-pointer' : 'cursor-not-allowed'" @click="switchAccountHandler(company)">
        <div class="flex justify-between">
          <div class="flex">
            <div v-if="!company.avatar_url" class="flex items-center justify-center w-10 h-10 rounded bg-blue-dark-50 text-blue-dark-200">
              <BaseIcon
                :icon="company.account_type === 'personal' ? 'account-circle' : 'domain'"
              />
            </div>
            <div
              v-else
              :style="{ 'background-image': 'url(' + company.avatar_url + ')', 'background-size': '100% 100%' }"
              class="border-[1.3px] border-primary-500 w-10 h-10 rounded-md cursor-pointer"
            >
            </div>
            <div class="flex flex-col justify-between mr-3">
              <div class="text-sm font-bold text-blue-dark-500" :class="select == company.id && 'text-primary-500'">
                {{ company.title }}
              </div>
              <div class="text-xs text-blue-dark-200" :class="select == company.id && 'text-primary-500'">
                {{ company.account_type === 'personal' ? 'حقیقی' : 'حقوقی' }}
              </div>
            </div>
          </div>
          <div>
            <div v-if="!company.status" class="text-xs text-center text-red-600">
              <BaseIcon icon="error" fill />
              <div>مسدود</div>
            </div>
            <BaseIcon v-else-if="select === company.id" icon="radio-button-checked" class="text-blue-500" />
            <BaseIcon v-else icon="radio-button-unchecked" class="text-blue-dark-400" />
          </div>
        </div>
        <div class="border-b-[1px] w-full mt-3"></div>
      </div>
      <div v-if="loading" class="flex flex-col gap-y-[22px] animate-pulse">
        <div v-for="i in 3" :key="i" class="w-full h-[46px] bg-gray-300 rounded"></div>
      </div>
    </BaseBottomSheet>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref } from 'vue'
import BaseModal from "@/components/base/BaseModal.vue";
import { apiGetUserAccounts } from "@/services/authentication/authentication";
import { useAuthStore } from "@/stores/authStore";
import { useRoute, useRouter } from 'vue-router';
import BaseBottomSheet from "@/components/base/BaseBottomSheet.vue";
import { useDisplay } from 'vuetify';

const route = useRoute()
const { smAndDown } = useDisplay()
const authStore: any = useAuthStore();
const accounts: any = ref([])
const select: any = ref(null)
const modal = ref()
const showAccounts = ref(false)
const loading = ref(false)
const getUserAccounts = async () => {
  loading.value = true
  try {
    const {data} = await apiGetUserAccounts()
    accounts.value = data.companies
    const companyId = localStorage.getItem('company')    
    companyId ? select.value = Number(companyId) : select.value = authStore.userInfo.id
  } catch (error) {
    console.log(error);
  }
  loading.value = false
}
getUserAccounts()

const openDialogAfterLogin = async () => {
  if (!authStore.userInfo?.companies_count) {
    return
  }
  const action = route.query?.action
  await nextTick()
  if (action && action == 'account') {
    if (smAndDown.value) {
      showAccounts.value = true
      return
    }
    modal.value.showDialog()
  }
}
openDialogAfterLogin()
const closeDialog = (isActive: any) => {
  isActive.value = false
}
const openDialog = (isActive: any) => {
  modal.value.showDialog()
}
defineExpose({
  openDialog
});
const useAccount = () => {
  const selectedItem = accounts.value.find((item: any) => item.id === select.value)
  if (selectedItem.account_type == 'personal') {
    localStorage.setItem('company', '')
    if (modal.value) {
      modal.value.closeDialog()
    } else showAccounts.value = false
    window.open('/dashboard', '_self')
    return
  }
  localStorage.setItem('company', select.value)
  if (modal.value) {
    modal.value.closeDialog()
  } else showAccounts.value = false
  window.open('/dashboard', '_self')
}
const switchAccountHandler = (company: any) => {
  company.status ? select.value = company.id : undefined
  useAccount()
}
</script>